module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJUExURUdwTCguNiguOq1wfxYAAAACdFJOUwCF60G6lwAAAB1JREFUKM9jYKAXyFoFBSuBnFVwgC4zmMGoFygGAIDTOj+sNK+hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_menu_icon.png
// module id = DycO
// module chunks = 34